import Vue from 'vue'
import store from './store'
import router from './router'
import App from './components/App'
import ProgressBar from './components/elements/ProgressBar'
import syncClaims from './lib/claims'
import inputAutoWidth from 'vue-input-autowidth'
import VueScrollTo from 'vue-scrollto'
import { sync } from 'vuex-router-sync'
import Vue2Storage from 'vue2-storage'

Vue.config.productionTip = false

// You can specify the plug-in configuration when connecting, passing the second object to Vue.use
Vue.use(Vue2Storage, {
  prefix: 'px_',
  driver: 'local',
  ttl: 60 * 60 * 24 * 1000
})

// global progress bar
const bar = Vue.prototype.$bar = new Vue(ProgressBar).$mount()
document.body.appendChild(bar.$el)

Vue.use(inputAutoWidth)
Vue.use(VueScrollTo)

sync(store, router)
syncClaims(store, router, {
  route: function (to) {
    return {
      path: '/auth',
      query: { redirect: to.fullPath }
    }
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
